import createEducationBarStorage from "app/pages/sales-intelligence/sub-modules/education-bar/services/storage/factory";
import type { ModuleStorage } from "app/pages/sales-intelligence/services/storage/types";

export default function createCompanyOverviewStorage(storageProvider: ModuleStorage) {
    return Object.assign({}, createEducationBarStorage(storageProvider));
}
